import { registryApi, walterApi } from '../clients/AxiosClients'

export const getAllEstratoInventarioFlorestal = () => {
	return registryApi.get('v2/EstratoInventarioFlorestal/lista-dados-para-grid')
}

/**
 * Retorna todos os processos de inventário florestal cadastrados no banco de dados com paginação
 * @param {number} PagNumber - Número da página
 * @param {number} PagSize - Tamanho da página
 * @param {string} FilteringWord - Palavra chave busca  */

export const getAllEstratosInventarioFlorestalPagination = async (
	PagNumber,
	PagSize,
	FilteringWord,
) => {
	return registryApi.post('v2/EstratoInventarioFlorestal/GetToCrudTable', {
		PagNumber,
		PagSize,
		FilteringWord,
	})
}

export const updateEstratoInventarioFlorestalAsync = (estratoInventarioFlorestal) => {
	console.log(
		'🚀 ~ file: EstratoInventarioFlorestalRequests.js:8 ~ updateEstratoInventarioFlorestalAsync ~ estratoInventarioFlorestal',
		estratoInventarioFlorestal,
	)
	return registryApi.put('v1/EstratoInventarioFlorestal/Async', estratoInventarioFlorestal)
}

export const saveChosenHipsometricoModel = (data) => {
	return walterApi.post('/ProcessamentoHipsometrico/SaveChosenHipsometricoModel', data)
}

export const createEstratoInventario = (eifl) => {
	return registryApi.post(
		'v2/EstratoInventarioFlorestal/salva-estrato-inventario-florestal-sortimento/',
		[eifl],
	)
}

export const classificaComoInventarioOficial = (inventarioOficial) => {
	console.log(
		'🚀 ~ file: EstratoInventarioFlorestalRequests.js:33 ~ classificaComoInventarioOficial ~ inventarioOficial',
		inventarioOficial,
	)
	return registryApi.post(
		'v2/EstratoInventarioFlorestal/classifica-como-inventario-oficial',
		inventarioOficial,
		{
			headers: {
				'Content-Type': 'application/json',
			},
		},
	)
}

export const ajustaModeloHipsometrico = (data) => {
	return walterApi.post('/ProcessamentoHipsometrico/AjustaModeloHipsometrico/', data)
}

export const processaInventario = (data) => {
	return walterApi.post('/ProcessamentoInventarioFlorestal/ProcessaInventario/', data)
}

export const getAllHipsometricoWithGraphicByEiflId = (id) => {
	return walterApi.get(`/StatisticalAnalysis/GetAllHipsometricoWithGraphicByEiflId?id=${id}`)
}

export const deleteEstratoInventarioFlorestalByIdList = (estratoFlorestalIdList) => {
	return registryApi.delete('v1/EstratoInventarioFlorestal/DeleteByIdList', {
		data: estratoFlorestalIdList.map((id) => id.toString()),
	})
}
